// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/fonts/GTEestiBold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/fonts/AvenirBook.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/fonts/AvenirBlack.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/fonts/AvenirOblique.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*******************************************************
 *                                                     *
 *                VIAJES TEIDE                         *
 *                                                     *
 *        developed: Javier Vega Martinez              *
 *        contact: info@emdbwebprojects.com            *
 *        copyright - 2014-2024                        *
 *                                                     *
 *******************************************************/
/* width */
/* fonts */
@font-face {
  font-family: GTEestiBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
@font-face {
  font-family: AvenirBook;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
@font-face {
  font-family: AvenirBlack;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
@font-face {
  font-family: AvenirOblique;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
/* debug */
.debug-qJIEr {
  background-color: #ff7f50;
}
.debug2-ylYQd {
  background-color: #6495ed;
}
.cartfinal-Uu1nw {
  text-align: center;
  width: 100%;
}
.cartfinal-Uu1nw .title-T8Yti {
  font-family: AvenirBlack;
  font-size: 1.75em;
  color: #99CC33;
  margin: 20px 0px;
}
.cartfinal-Uu1nw .title_error-ZhxND {
  font-family: AvenirBlack;
  font-size: 1.75em;
  color: #BF1E4B;
  margin: 20px 0px;
}
.cartfinal-Uu1nw .error_code-uoLQM {
  font-family: AvenirBook;
  font-size: 1em;
  color: #BF1E4B;
  margin-bottom: 10px;
}
.cartfinal-Uu1nw .text-Xmz0I {
  font-family: AvenirBook;
  font-size: 1.25em;
  margin-bottom: 10px;
}
.cartfinal-Uu1nw li {
  font-family: AvenirBook;
  font-size: 1.125em;
  list-style: none;
}
@media only screen and (max-width: 800px) {
  .cartfinal-Uu1nw {
    text-align: center;
    width: 100%;
  }
  .cartfinal-Uu1nw .title-T8Yti {
    font-size: 1.625em;
  }
  .cartfinal-Uu1nw .title_error-ZhxND {
    font-size: 1.625em;
  }
  .cartfinal-Uu1nw .error_code-uoLQM {
    font-size: 1em;
  }
  .cartfinal-Uu1nw .text-Xmz0I {
    font-size: 1.125em;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/VTCartFinal/VTCartFinal.module.less","webpack://./src/assets/css/theme.less"],"names":[],"mappings":"AAAA;;;;;;;;wDAQwD;AACxD,UAAU;AACV,UAAU;ACwBV;EAAY,wBAAA;EAA0B,4CAAA;ADpBtC;ACqBA;EAAY,uBAAA;EAAyB,4CAAA;ADjBrC;ACkBA;EAAY,wBAAA;EAA0B,4CAAA;ADdtC;ACeA;EAAY,0BAAA;EAA4B,4CAAA;ADXxC;AACA,UAAU;ACiBV;EAAQ,yBAAA;ADdR;ACeA;EAAS,yBAAA;ADZT;AA/BA;EAAW,kBAAA;EAAoB,WAAA;AAmC/B;AAnCA;EACS,wBAAA;ECqCP,iBAAA;EDrCgD,cAAA;EAAoB,gBAAA;AAwCtE;AAzCA;EAEe,wBAAA;ECoCb,iBAAA;EDpCsD,cAAA;EAAe,gBAAA;AA6CvE;AA/CA;EAGc,uBAAA;ECmCZ,cAAA;EDnCoD,cAAA;EAAe,mBAAA;AAkDrE;AArDA;EAIQ,uBAAA;ECkCN,iBAAA;EDlC+C,mBAAA;AAsDjD;AA1DA;EAKM,uBAAA;ECiCJ,kBAAA;EDjC4C,gBAAA;AA0D9C;AAxDA;EACE;IAAW,kBAAA;IAAoB,WAAA;EA4D/B;EA5DA;IC8BA,kBAAA;EDiCA;EA/DA;IC8BA,kBAAA;EDoCA;EAlEA;IC8BA,cAAA;EDuCA;EArEA;IC8BA,kBAAA;ED0CA;AACF","sourcesContent":["@import \"../../assets/css/theme\";\n\n.cartfinal{text-align: center; width: 100%;\n  .title{font-family:AvenirBlack; .font-base(28); color:@colorverde1; margin:20px 0px;}\n  .title_error{font-family:AvenirBlack; .font-base(28); color:#BF1E4B; margin:20px 0px;}\n  .error_code{font-family:AvenirBook; .font-base(16); color:#BF1E4B; margin-bottom: 10px;}\n  .text{font-family:AvenirBook; .font-base(20);  margin-bottom: 10px;}\n  li{ font-family:AvenirBook; .font-base(18); list-style: none;}\n}\n@media only screen and (max-width : 800px) {\n  .cartfinal{text-align: center; width: 100%;\n    .title{.font-base(26);}\n    .title_error{.font-base(26);}\n    .error_code{.font-base(16);}\n    .text{.font-base(18);  }\n  }\n}\n\n\n\n\n\n","/*******************************************************\n *                                                     *\n *                VIAJES TEIDE                         *\n *                                                     *\n *        developed: Javier Vega Martinez              *\n *        contact: info@emdbwebprojects.com            *\n *        copyright - 2014-2024                        *\n *                                                     *\n *******************************************************/\n\n//VARS\n\n@colorverde1: #99CC33;  //verde 1\n@colorverde2: #009933;  //verde 2\n@colorverde3: #BEE266;  //verde 3\n@colorazul1: #33CCFF;   //azul 1\n@colorrosa1: #FF6698;   //rosa 1\n\n@colorgris1: #E1E1E1;   //Gris background footer\n@colorgris2: #999999;   //Gris text\n@colorgris3: #666666;   //Gris text\n@colorgris4: #333333;   //Gris text\n@colorgris5: #5D5D5D;\n\n/* width */\n@width-space:20px;\n@width-column:40px;\n@width-content: 1100px;\n@width-total: @width-content + 20px;\n@width-min:400px;\n\n/* fonts */\n@em:16px;\n\n@font-face {font-family: GTEestiBold; src: url('../fonts/GTEestiBold.otf'); }\n@font-face {font-family: AvenirBook; src: url('../fonts/AvenirBook.otf'); }\n@font-face {font-family: AvenirBlack; src: url('../fonts/AvenirBlack.ttf'); }\n@font-face {font-family: AvenirOblique; src: url('../fonts/AvenirOblique.otf'); }\n\n.font-base(@sizeValue) {\n  font-size: unit(( @sizeValue / @em ), em);\n}\n\n/* debug */\n.debug {background-color:#ff7f50;}\n.debug2 {background-color:#6495ed ;}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"debug": `debug-qJIEr`,
	"debug2": `debug2-ylYQd`,
	"cartfinal": `cartfinal-Uu1nw`,
	"title": `title-T8Yti`,
	"title_error": `title_error-ZhxND`,
	"error_code": `error_code-uoLQM`,
	"text": `text-Xmz0I`
};
export default ___CSS_LOADER_EXPORT___;
